export default "__VITE_ASSET__CD2GV8ZH__"